<template lang="pug">
v-progress-circular(
  :size="50"
  color="primary"
  indeterminate
).loader
</template>

<script>
export default {
  name: 'Loader'
}
</script>

<style scoped lang="sass">
  .loader
    color: #2E8B57
    margin-top: 50vh
    margin-left: 50vw
</style>
